import CryptoJS from 'crypto-js/core';

export const sha256Hash = (input: string): string => {
  return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
};
